var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38776 5.5291L13.7632 1.15274C14.6335 0.282422 16.0445 0.282421 16.9149 1.15274C17.7015 1.93937 17.7773 3.16862 17.1415 4.03991L16.902 4.31731L12.5372 8.67827L12.1833 9.03184L12.537 9.38554L16.9141 13.7624C17.7845 14.6328 17.7845 16.0438 16.9141 16.9141C16.1275 17.7008 14.8982 17.7766 14.027 17.1407L13.7495 16.9012L9.38776 12.5385L9.03419 12.1849L8.6806 12.5385L4.30515 16.9141C3.43484 17.7845 2.02378 17.7845 1.15346 16.9141C0.366839 16.1275 0.290988 14.8983 0.926871 14.027L1.16647 13.7494L5.52779 9.38543L5.88116 9.03184L5.52764 8.67839L1.15274 4.30443C1.15272 4.30442 1.15271 4.30441 1.1527 4.3044C0.282421 3.43408 0.282433 2.02304 1.15274 1.15274C1.93936 0.366112 3.16862 0.29026 4.0399 0.926144L4.31738 1.16569L8.6806 5.52913L9.03419 5.88274L9.38776 5.5291Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.8e7083a8.svg";
export { ForwardRef as ReactComponent };